import { ContentManagerModule, Context, SxcAppComponent } from '@2sic.com/sxc-angular';
import { AsyncPipe, NgClass } from '@angular/common';
import { Component, ElementRef, inject, signal } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterLink, RouterOutlet } from '@angular/router';
import { Observable, filter, map, startWith } from 'rxjs';
import { AuthService } from './auth/auth.service';
import { RoutesConst } from './shared/route-const';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  imports: [RouterOutlet, AsyncPipe, RouterLink, NgClass, ContentManagerModule],
})
export class AppComponent extends SxcAppComponent {
  public authSvc = inject(AuthService);
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);

  routesConst = RoutesConst;
  currentUrl = signal(this.router.url);

  // Whether to show the side navigation - based on route data
  showSideNav$: Observable<boolean> = this.router.events.pipe(
    filter((e): e is NavigationEnd => e instanceof NavigationEnd),
    startWith(null),
    map(() => {
      let r = this.activatedRoute;
      while (r.firstChild) r = r.firstChild;
      return r.snapshot.data['showSideNav'] !== false;
    }),
  );

  constructor(el: ElementRef, context: Context) {
    super(el, context);
    // Listen for messages from the skin to exit impersonation
    window.addEventListener('message', (event) => {
      try {
        const data = JSON.parse(event.data);
        if (data.type === 'exit-impersonation') {
          this.authSvc.exitImpersonation();
        }
      } catch (e) {
        // console.log(":", event.data);
      }
    });
  }

  ngOnInit() {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      this.currentUrl.set(event.urlAfterRedirects);
    });
  }

  checkActiveUrl(url: string): boolean {
    return this.currentUrl().includes(url);
  }
}
